import React from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import { sortLpTokens } from 'utils/lpUtils'
import LpIcon from 'components/Logo/LpIcon'
import TokenIcon from 'components/Logo/TokenIcon'

export interface ExpandableSectionProps {
  ranch: any
}

const Wrapper = styled.div`
  margin-bottom: 26px;
`

const ImageWrapper = styled.div`
  text-align: center;
`
const ImageContainer = styled.span`
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
`

const ArrowContainer = styled(ImageContainer)`
  margin: 5px 20px;
`

const LabelWrapper = styled(Text)`
  font-family: 'Verdana',sans-serif;
  text-align: center;
  word-break: break-word;
`

const NameWrapper = styled(LabelWrapper)`
  font-size: 22px;
  padding: 0px 42px 24px 42px;
`

const CardHeading: React.FC<ExpandableSectionProps> = ({
  ranch
}) => {
  const tokens = sortLpTokens(ranch.lpToken.token0, ranch.lpToken.token1);
  return (
    <Wrapper>
      <NameWrapper>{`${tokens[0].symbol}-${tokens[1].symbol}`} LP</NameWrapper>
      <ImageWrapper>
        <ImageContainer>
          <LpIcon token0={tokens[0].address} token1={tokens[1].address} />
        </ImageContainer>
        <ArrowContainer>
          <img src="/images/ranches/arrow3.png" alt="Arrow" width="32" height="32" style={{width:32,height:32}}/>
        </ArrowContainer>
        <ImageContainer>
          <TokenIcon token={ranch.token.address} /> 
        </ImageContainer>
      </ImageWrapper>
    </Wrapper>
  )
}

export default CardHeading
